import { FileLock2 } from 'lucide-react';
import LegalDocument from '@/components/LegalDocument';

export default function Dpa() {
  return <LegalDocument docKey="dpa_doc" icon={FileLock2} />;
}
